module.exports = __webpack_public_path__ + "static/fonts/AntipastoPro.b2bf8249.ttf";